export default "__VITE_ASSET__s2AbTeNP__"